import React from "react"
import ReactWOW from "react-wow"
import { useStaticQuery, graphql } from "gatsby"
import MiniContactForm from "../Index/MiniContactFormRedesign"
import Badges from "../PartnerBadgeSections/Roostbadge"
import SourceIdentifier from "../Common/SourceIdentifier"
import { Link } from "gatsby"

const RoostBanner = props => {
  const responseData = useStaticQuery(graphql`
    query GetPartnerOORatesQuery {
      allStrapiRateCards(
        filter: {
          Rate_Name: {
            in: ["Interest_Rate_OO", "LVR_OO", "Comparison_Rate_OO"]
          }
        }
      ) {
        edges {
          node {
            Rate_Name
            Rate_Value
          }
        }
      }
    }
  `)
  console.log("data", responseData)
  console.log("props", props)

  const interestRateOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "Interest_Rate_OO"
    ).node.Rate_Value || "N/A"

  const comparisonRateOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "Comparison_Rate_OO"
    ).node.Rate_Value || "N/A"

  const lvrOO =
    responseData.allStrapiRateCards.edges.find(
      edge => edge.node.Rate_Name === "LVR_OO"
    ).node.Rate_Value || "N/A"

  console.log(props.partner.Code)
  const partnerName = SourceIdentifier(props.partner.Code)

  return (
    <div className="home-hero-banner-revamp partner-banner">
      <div className="container hero">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-12 my-5">
            <div className="hero-title-wrapper mt-5">
              {/* <ReactWOW delay=".5s" animation="fadeInDown"> */}
              <div className="chevron-up"></div>
              {/* </ReactWOW> */}
              <h1 className="hero-title">
                Home Loans <span className="">Made Simple </span>
                <ReactWOW delay=".5s" animation="fadeInDown">
                  <sup className=""> TM</sup>
                </ReactWOW>
              </h1>
            </div>
            <h2 className="mb-4">Find a better home loan in minutes.</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-8 col-lg-6">
            <div className="row">
              <div className="col-lg-7 col-md-12">
                <ReactWOW delay=".05s" animation="fadeInUp">
                  <div className="d-flex justify-content-center h-100">
                    <div className="rates-comparison">
                      <Badges parnerBadge={props.partner.logo[0].url} />
                      <div className="">
                        <div className="row">
                          <div className="col-6 mb-4 mb-lg-0 col-lg-12">
                            <div className="rates-group">
                              <label>Rates from</label>
                              <div className="rate-wrapper">
                                <h2 className="rate">{interestRateOO}</h2>
                                <div className="percentage">
                                  <p className="percentage-symbol d-flex flex-column">
                                    %<span>p.a</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 col-lg-12">
                            <div className="rates-comparison-group">
                              <label>Comparison</label>
                              <div className="rate-wrapper">
                                <h2 className="rate">
                                  {comparisonRateOO}
                                </h2>
                                <div className="percentage">
                                  <p className="percentage-symbol d-flex flex-column">
                                    %<span>p.a</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="green-corona custom-green-corona"></div>
                      </div>
                      <div className="owner-occupied mb-4">
                        <p>Owner occupied | P&I | {lvrOO}% LVR </p>
                      </div>

                      <ReactWOW delay=".05s" animation="fadeInUp">
                        <div className="btn-box">
                          <Link
                            to="/book-a-call"
                            className="default-btn mid-width-btn primary-btn btn-lg mb-2 mr-sm-3 mr-lg-2"
                            rel="noopener noreferrer"
                          >
                            Talk to an Expert<span></span>
                          </Link>
                        </div>
                      </ReactWOW>
                    </div>
                  </div>
                </ReactWOW>
              </div>
              <div className="col-lg-5 col-md-12 mt-lg-0 mt-4">
                <ReactWOW delay=".05s" animation="fadeInUp">
                  <div className="row">
                    <div className="col-lg-12 col-md-6 col-6 mb-lg-4">
                      <Link to="/calculators">
                        <div className="calculator-tile">
                          <div className="white-puncture-bottom"></div>
                          <h5>Try Calculators</h5>
                          <div className="icon-calculator"></div>
                        </div>
                      </Link>
                    </div>

                    <div className="col-lg-12 col-md-6 col-6">
                      <Link to="/about-us">
                        <div className="home-tile h-100">
                          <div className="white-puncture"></div>
                          <h5>About Us</h5>
                          <div className="icon-home"></div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </ReactWOW>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6">
            <MiniContactForm partner={props.partner.Code} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoostBanner
